module.exports = __webpack_public_path__ + "img/news_pack_results.2fcff51c.svg";